import React from 'react';
import { Box } from '@mui/material';
import CalendarHeaderLayout from '../common/CalendarHeaderLayout';
import SchedulePlannerNavigation from './schedule-planner-header/SchedulePlannerNavigation';
import SchedulePlannerTitle from './schedule-planner-header/SchedulePlannerTitle';

const headerBoxStyles = {
    marginBottom: "0.5rem",
};

const SchedulePlannerToolbar = ({onRefresh, toolbar, showTimeblocks, setShowTimeblocks}) => {
    const {label, onNavigate} = toolbar;

    return (
        <Box sx={headerBoxStyles}>
            <CalendarHeaderLayout
                actionPanelContainer={<SchedulePlannerNavigation onNavigate={onNavigate} onRefresh={onRefresh} showTimeblocks={showTimeblocks} setShowTimeblocks={setShowTimeblocks} />}
                titleContainer={<SchedulePlannerTitle title={label} />}
                contextOptionContainer={null}
            />
        </Box>
    );
};

export default SchedulePlannerToolbar;